
<div class="sticky-toolbar mb-8 text-[14px]">
    <p-toolbar class="text-[14px] p-0">
        <ng-template #start>
            <button pButton type="button" icon="pi pi-print" label="Print" class="p-button-sm p-button-secondary" (click)="printPickingList()"></button>
            <!-- <button pButton type="button" icon="pi pi-file-pdf" label="Export as PDF" class="p-button-sm p-button-secondary ml-2" (click)="exportToPDF()"></button> -->
            <div class="language-select ml-4">
                <label for="languageSelect" class="mr-2">Language:</label>
                <select id="languageSelect" [(ngModel)]="selectedLanguage" (ngModelChange)="onLanguageChange()">
                    <option value="en">English</option>
                    <option value="de">German</option>
                    <option value="nl">Dutch</option>
                </select>
            </div>
            <p-toast />
        </ng-template>
        <ng-template #end>
            <button pButton type="button" icon="pi pi-arrow-left" label="Back" class="p-button-sm p-button-secondary ml-2" (click)="goBack()"></button>
        </ng-template>
    </p-toolbar>
</div>

<div #pickingList>
    <ng-container *ngFor="let pageLines of paginatedContent">
        <div *ngIf="pageLines.length" class="invoice-wrapper">
            <!-- Header -->
            <div class="header-top">
                <img *ngIf="div1 === '400'; else deHeader" src="assets/Header.jpg" alt="Sidhu Food B.V. Logo" class="logo" />
                <ng-template #deHeader>
                    <img src="assets/header_DE.jpg" alt="Sidhu Food B.V. Logo DE" class="logo" />
                </ng-template>
            </div>
            <div class="main-content">
                <div class="address-invoice-row">
                    <div class="address-block">
                        <table class="address-table mt-6">
                            <tr>
                                <b><td >{{ getLabel('vehicleNo') }}</td></b>
                                <td>:</td>
                                <td>{{ pickingListDetails.vehicleNo }}</td>
                            </tr>
                            <tr>
                                <b><td>{{ getLabel('driverNo') }}</td></b>
                                <td>:</td>
                                <td>{{ pickingListDetails.driverNo }}</td>
                            </tr>
                            <tr>
                              <b>  <td >{{ getLabel('route') }}</td></b>
                                <td>:</td>
                                <td>
                                    <input type="text" class="route-input" readonly />
                                </td>
                            </tr>
                        </table>
                    </div>
                    <div class="invoice-block">
                        <div class="invoice-title">
                            <b>{{ getLabel('pickingListTitle') }}</b>
                        </div>
                        <table>
                            <!-- <tr>
                                <td>{{ getLabel('fromDate') }}</td>
                                <td>:</td>
                                <td>{{ pickingListDetails.fromDate }}</td>
                            </tr>
                            <tr>
                                <td>{{ getLabel('toDate') }}</td>
                                <td>:</td>
                                <td>{{ pickingListDetails.toDate }}</td>
                            </tr> -->
                            <tr>
                                <td>{{ getLabel('picklistNo') }}</td>
                                <td>:</td>
                                <td>{{ pickingListDetails.picklistNo }}</td>
                            </tr>
                        </table>
                    </div>
                </div>
                <table class="items-table">
                    <thead>
                        <tr>
                            <th>{{ getLabel('orderNumber') }}</th>
                            <th>{{ getLabel('date') }}</th>
                            <th>{{ getLabel('customerName') }}</th>
                            <th>{{ getLabel('itemName') }}</th>
                            <th>{{ getLabel('quantity') }}</th>
                            <th>{{ getLabel('size') }}</th>
                            <th>{{ getLabel('pcs') }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <ng-container *ngFor="let line of pageLines">
                            <tr [class.order-separator]="line.orderLineIndex === line.orderLinesLength - 1">
                                <td *ngIf="line.isFirstOnPage" [attr.rowspan]="line.rowspanOnPage" style="vertical-align: top;">{{ line.orderNo }}</td>
                                <td *ngIf="line.isFirstOnPage" [attr.rowspan]="line.rowspanOnPage" class="min-w-24" style="vertical-align: top;">
                                    {{ line.creationDate }}
                                </td>
                                <td *ngIf="line.isFirstOnPage" [attr.rowspan]="line.rowspanOnPage" style="vertical-align: top;">{{ line.customerName }}</td>
                                <td style="text-align: center;">{{ line.itemName }}</td>
                                <td>{{ line.quantity }}</td>
                                <td>{{ line.size }}</td>
                                <td style="text-align: center;">{{ line.pcs }}</td>
                            </tr>
                        </ng-container>
                    </tbody>
                </table>
            </div>

            <div class="watermark-footer">
                <img src="assets/torna_logo.png" alt="Watermark" />
            </div>
            <div class="footer">
                <img *ngIf="div1 === '400'; else deFooter" src="assets/Footer.jpg" alt="Sidhu Food B.V. Footer" class="footer-logo" />
                <ng-template #deFooter>
                    <img src="assets/footer_DE.jpg" alt="Sidhu Food B.V. Footer DE" class="footer-logo" />
                </ng-template>
            </div>
        </div>
    </ng-container>

    <!-- Consolidated Picklist: Each page is a full invoice-wrapper -->
    <ng-container *ngFor="let page of consolidatedItemsPaginated; let i = index">
        <div class="invoice-wrapper page-break-demo">
            <!-- Header -->
            <div class="header-top">
                <img *ngIf="div1 === '400'; else deHeaderLast" src="assets/Header.jpg" alt="Sidhu Food B.V. Logo" class="logo" />
                <ng-template #deHeaderLast>
                    <img src="assets/header_DE.jpg" alt="Sidhu Food B.V. Logo DE" class="logo" />
                </ng-template>
            </div>
            <div class="main-content">
                <div class="address-invoice-row">
                    <div class="address-block"></div>
                    <div class="invoice-block">
                        <div class="invoice-title text-center">
                            <b>{{ getLabel('RouteWiseConsodilated') }}</b>
                        </div>
                        <div class="picklist-details text-right">
                            <!-- <div>{{ getLabel('fromDate') }} : {{ pickingListDetails.fromDate }}</div>
                            <div>{{ getLabel('toDate') }} : {{ pickingListDetails.toDate }}</div> -->
                            <div>{{ getLabel('picklistNo') }} : {{ pickingListDetails.picklistNo }}</div>
                        </div>
                    </div>
                </div>
                <table class="items-table" style="width: 100%; margin-bottom: 24px; table-layout: fixed;">
                    <colgroup>
                        <col style="width: 90px;" />      <!-- Artikelnummer -->
                        <col style="width: 320px;" />     <!-- Omschrijving (itemName) -->
                        <col style="width: 100px;" />     <!-- Inhoud (size) -->
                        <col style="width: 80px;" />      <!-- Stuks (pcs) -->
                        <col style="width: 100px;" />     <!-- Hoeveelheid (quantity) -->
                    </colgroup>
                    <thead>
                        <tr>
                            <th>{{ getLabel('itemNo') }}</th>
                            <th>{{ getLabel('itemName') }}</th>
                            <th>{{ getLabel('size') }}</th>
                            <th>{{ getLabel('pcs') }}</th>
                            <th>{{ getLabel('quantity') }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let item of page; let j = index" [ngClass]="{'bold-row': item.itemGroup === '11000'}">
                            <td>{{ item.itemNo }}</td>
                            <td>{{ item.itemName }}</td>
                            <td>{{ item.size }}</td>
                            <td style="text-align: center;">{{ item.pcs }}</td>
                            <td style="text-align: center;">{{ item.quantity }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="watermark-footer">
                <img src="assets/torna_logo.png" alt="Watermark" />
            </div>
            <div class="footer">
                <img *ngIf="div1 === '400'; else deFooterLast" src="assets/Footer.jpg" alt="Sidhu Food B.V. Footer" class="footer-logo" />
                <ng-template #deFooterLast>
                    <img src="assets/footer_DE.jpg" alt="Sidhu Food B.V. Footer DE" class="footer-logo" />
                </ng-template>
            </div>
        </div>
    </ng-container>
</div>



